import React, { useEffect, useRef, useState } from "react";
import "./network-status-banner.css";

export const NETWORK_RESTORED_EVENT = "dworks:network-restored";

export default function NetworkStatusBanner({ onReconnect }) {
  const [status, setStatus] = useState(() =>
    typeof navigator !== "undefined" && navigator.onLine === false ? "offline" : "online"
  );
  const previousOnlineRef = useRef(status !== "offline");
  const reconnectRef = useRef(onReconnect);
  const clearTimerRef = useRef(null);
  const dispatchTimerRef = useRef(null);

  useEffect(() => {
    reconnectRef.current = onReconnect;
  }, [onReconnect]);

  useEffect(() => {
    const clearTimers = () => {
      if (clearTimerRef.current) window.clearTimeout(clearTimerRef.current);
      if (dispatchTimerRef.current) window.clearTimeout(dispatchTimerRef.current);
    };

    const handleOffline = () => {
      clearTimers();
      previousOnlineRef.current = false;
      setStatus("offline");
    };

    const handleOnline = () => {
      if (previousOnlineRef.current) return;
      previousOnlineRef.current = true;
      setStatus("restored");
      clearTimers();

      dispatchTimerRef.current = window.setTimeout(() => {
        window.dispatchEvent(new CustomEvent(NETWORK_RESTORED_EVENT));
        reconnectRef.current?.();
      }, 500);

      clearTimerRef.current = window.setTimeout(() => {
        setStatus("online");
      }, 3500);
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      clearTimers();
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  if (status === "online") return null;

  return (
    <div
      className={`dw-network-status dw-network-status--${status}`}
      role="status"
      aria-live="polite"
    >
      <span className="dw-network-status__dot" aria-hidden="true" />
      <span>
        {status === "offline"
          ? "인터넷 연결이 끊겼습니다. 입력 중인 내용은 유지됩니다."
          : "인터넷이 다시 연결되었습니다. 최신 정보를 확인하고 있습니다."}
      </span>
    </div>
  );
}
